<template>
    <div class="data_brain_wrap">
        <div class="qqfn_banner">
            <div>
                <p>打造新能源企业</p>
                <p>“请进来”与“走出去”</p>
                <p>的双桥头堡和国内外新能源头部企业总部集聚地。</p>
            </div>
        </div>
        <div class="qqfn_intro_one">
            <div class="intro_content">
                <h2>全球赋能中心 —  </h2>
                <p>根据全球新能源产业发展的最新趋势，结合上海市经信委的工作要求和新能源行业协会的功能职责，在市经信委的指导和虹桥国际商务区、临港集团的大力支持下，“全球新能源赋能中心”于2024年9月24日隆重揭牌成立。</p>
                <div></div>
            </div>
            <div class="intro_img"></div>
        </div>
        <div class="qqfn_intro_two">
            <div class="qqfn_intro_card">
                <div class="card_icon"></div>
                <h2>引领国内企业走向国际</h2>
                <div>
                    中心所在地虹桥国际商务区国际化程度高，商业环境成熟，汇聚了众多跨国公司，是国内外企业总部和贸易机构的汇集地，同时拥有雄厚的产业基础及丰富的创新资源，有助于赋能企业更高效的获取信息、统筹调配资源、开拓市场，立足长三角，走向全世界。
                    <br/><br/>
                    而全球新能源赋能中心一层将配备设立采购中心，展出太阳能企业的产品与技术，将国内企业推向世界。
                </div>
            </div>
            <div class="qqfn_intro_card">
                <div class="card_icon"></div>
                <h2>助力国际企业导入中国</h2>
                <div>
                    依托独特的区位优势，便捷的交通网络，开放的经济环境与国际化的商业氛围，全球新能源赋能中心将作为国际企业登陆中国的第一站，我们将助力企业快速融入、辐射全国。
                    <br/><br/>
                    中心将设立企业服务中心、外籍人士服务专区，针对外籍人士来华办理永久居留申请、居留许可、工作许可、签证续期等相关事项为国际企业导入中国提供一站式便利化服务。
                </div>
            </div>
        </div>
        <div class="qqfn_intro_three">
            <h2>全球新能源赋能中心所在地——中骏广场</h2>
            <p>抢占虹桥枢纽，共赢商务未来！</p>
            <div class="trafficBox">
                <div class="trafficWrapper">
                    <div class="trafficIcon"></div>
                    <p>91条直达航线</p>
                </div>
                <div class="trafficWrapper">
                    <div class="trafficIcon"></div>
                    <p>56种换乘模式</p>
                    <p>5条轨道交通汇聚</p>
                </div>
                <div class="trafficWrapper">
                    <div class="trafficIcon"></div>
                    <p>7条高速路网纵横贯通</p>
                </div>
            </div>
        </div>
        <div class="qqfn_intro_four">
            <h2>
                功能与服务
                <span></span>
            </h2>
            
            <div class="serviceBox">
                <div class="serviceWrapper">
                    <img src="@/assets/qqfn/image04.png" alt="中小型论坛"/>
                    <h3>中小型论坛</h3>
                </div>
                <div class="serviceWrapper">
                    <img src="@/assets/qqfn/image03.png" alt="产品路演"/>
                    <h3>产品路演</h3>
                </div>
                <div class="serviceWrapper">
                    <img src="@/assets/qqfn/Image01.png" alt="现代化商务办公"/>
                    <h3>现代化商务办公</h3>
                </div>
            </div>
            <div class="serviceBox">
                <div class="serviceWrapper">
                    <img src="@/assets/qqfn/image05.png" alt="项目评审"/>
                    <h3>项目评审</h3>
                </div>
                <div class="serviceWrapper">
                    <img src="@/assets/qqfn/image02.png" alt="金融服务"/>
                    <h3>金融服务</h3>
                </div>
                <div class="serviceWrapper">
                    <img src="@/assets/qqfn/image06.png" alt="高端沙龙"/>
                    <h3>高端沙龙</h3>
                </div>
            </div>
        </div>
        <div class="qqfn_intro_five">
            <div>
                全球新能源赋能中心还将通过技术创新、产业升级、产品交易、展览展示、人才流动、产融结合、政企互动、国际合作等，设立政府服务窗口，营造新能源产业高质量发展的优质生态，为国内外新能源项目提供从孵化、加速到市场导入各不同阶段提供包括技术、资金、市场、管理、人才等全方位赋能，全过程助力新能源企业做大做强做优。
            </div>
        </div>
        <div class="qqfn_intro_six">
            <h2>更多详情请咨询我们</h2>
            <p>服务时间：周一至周五 9:00 - 18:00</p>
            <p>实地考察预约：上海市闵行区申长路888号中骏广场21号楼</p>
            <div class="contactBox">
                <div class="contactWrapper">
                    <i class="contactIcon"></i>
                    <span>400-XXX-XXXX</span>
                </div>
                <div class="contactWrapper">
                    <i class="contactIcon"></i>
                    <span>Q@163.com</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style>
.callme_total_wrap{margin-top: 0 !important;}
</style>
<style lang="scss" scoped>
.data_brain_wrap {
  padding: 60px 0 0;
  background-color: #fff;
  .qqfn_banner{
    width: 100%;
    height: calc(100vw / 4.8);
    background-image: url(../../assets/qqfn/banner.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    >div{
        display: flex;
        flex-direction: column;
        margin-left: 7%;
        font-size: 28px;
        line-height: 50px;
        color: #fff;
        >p:nth-child(2){
            font-weight: bold;
            font-size: 36px;
        }
    }
  }
  .qqfn_intro_one{
    width: 100%;
    display: flex;
    flex-direction: row;
    .intro_content{
        display: flex;
        flex-direction: column;
        color: #000;
        margin: 0 40px 0 296px;
        width: 29.27%;
        justify-content: center;
        >h2{
            font-size: 32px;
            line-height: 38px;
            font-weight: bold;
            margin-bottom: 40px;
        }
        >p{
            font-size: 20px;
            line-height: 30px;
        }
        >div{
            width: 58px;
            height: 8px;
            background-color:#832BC1;
            align-self: flex-end;
            margin-top: 58px;
        }
    }
    .intro_img{
        width: 1062px;
        height: 523px;
        background-image: url(../../assets/qqfn/1.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
  }
  .qqfn_intro_two{
    width: 100%;
    padding: 130px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 109px;
    .qqfn_intro_card{
        width: 577px;
        height: 651px;
        background-color: #203062;
        display: flex;
        flex-direction: column;
        padding: 66px 75px;
        color: #fff;
        .card_icon{
            width: 126px;
            height: 108px;
            background-image: url(../../assets/qqfn/Icon.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            align-self: center;
            margin-bottom: 63px;
        }
        >h2{
            font-size: 32px;
            font-weight: 700;
            line-height: 38.4px;
            margin-bottom: 26px;
        }
        >div{
            font-size: 20px;
            line-height: 28px;
        }
    }
    .qqfn_intro_card:last-child{
        margin-top: 63.5px;
        .card_icon{
            width: 127px;
            height: 118px;
            background-image: url(../../assets/qqfn/Icon2.png);
            margin-bottom: 55px;
        }
    }
  }
  .qqfn_intro_three{
    width: 75%;
    height: calc(100vw / 2.46);
    margin: 0 auto;
    background-image: url(../../assets/qqfn/2.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0 0 201px;
    color: #fff;
    >h2{
        font-size: 48px;
        font-weight: 700;
        line-height: 52.8px;
        margin-bottom: 28px;
    }
    >p{
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 46px;
    }
    .trafficBox{
        display: flex;
        flex-direction: row;
        gap: 53px;
        .trafficWrapper{
            display: flex;
            flex-direction: column;
            align-items: center;
            .trafficIcon{
                width: 83px;
                height: 83px;
                background-image: url(../../assets/qqfn/Stroke3.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                margin-bottom: 26.5px;
            }
            >p{
                font-size: 18px;
                font-weight: 700;
                line-height: 28px;
            }
        }
        .trafficWrapper:first-child{
            .trafficIcon{
                width: 83px;
                height: 83px;
                background-image: url(../../assets/qqfn/plane.png);
                margin-bottom: 36px;
            }
        }
        .trafficWrapper:last-child{
            .trafficIcon{
                background-image: url(../../assets/qqfn/Stroke2.png);
                margin-bottom: 36px;
            }
        }
    }
  }
  .qqfn_intro_four{
    width: 75%;
    margin: 115px auto 44px;
    >h2{
        font-size: 32px;
        font-weight: 700;
        line-height: 38.4px;
        color: #000;
        >span{
            width: 219px;
            height: 58px;
            background-color: #503AE7;
            float: right;
            margin: 71.4px 0 87px;
        }
    }
    .serviceBox{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 77px;
        .serviceWrapper{
            width: 466px;
            height: 424px;
            box-shadow: 0px 2px 4px  rgba(26, 15, 66, 0.21);
            display: flex;
            flex-direction: column;
            align-items: center;
            >img{
                width: 100%;
                height: 313px;
            }
            >h3{
                font-size: 24px;
                font-weight: 700;
                line-height: 30px;
                color: #000;
                height: 100%;
                display: flex;
                align-items: center;
            }
        }
    }
  }
  .qqfn_intro_five{
    width: 100%;
    height: calc(100vw / 2.52);
    background-image: url(../../assets/qqfn/3.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    >div{
        width: 656px;
        height: 204px;
        margin-right: 266px;
        font-size: 24px;
        font-weight: 400;
        line-height: 30px;
        color: #fff;
    }
  }
  .qqfn_intro_six{
    width: 100%;
    height: calc(100vw / 6);
    background-image: url(../../assets/qqfn/contact-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    >h2{
        font-size: 30px;
        font-weight: 400;
        line-height: 22px;
        color: #000;
    }
    >p:nth-child(2){
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #666;
        margin: 16px 0 19px;
    }
    >p:nth-child(3){
        font-size: 20px;
        font-weight: 400;
        line-height: 30px;
        color: #000;
    }
    .contactBox{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 40px;
        margin-top: 26px;
        .contactWrapper{
            width: 255px;
            height: 46px;
            background: #503AE7;
            color: #fff;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .contactIcon{
                display: inline-block;
                width: 26px;
                height: 29px;
                background-image: url(../../assets/qqfn/Stroke1.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                margin-right: 13px;
            }
            >span{
                font-size: 24px;
                font-weight: 400;
                line-height: 32.93px;
            }
        }
        .contactWrapper:last-child{
            .contactIcon{
                width: 24px;
                height: 24px;
                background-image: url(../../assets/qqfn/Edit.png);
                margin-right: 11px;
            }
        }
    }

  }
}
</style>